export const environment = {
    production: true,
    version: '1.0.6',
    endpoints: {
        'de': 'https://www.avicennaproject.eu/dm/de/api/v1',
        'ce': 'https://www.avicennaproject.eu/dm/ceed/api/v1',
        'res': 'https://www.avicennaproject.eu/dm/res/api/v1',
        'admin': 'https://www.avicennaproject.eu/admin/api',
        'images': {
            'iip': 'https://www.avicennaproject.eu/dm/res/api/v1/images/srv?FIF=phibor',
            'iiif': 'https://www.avicennaproject.eu/dm/res/api/v1/images/srv?IIIF=/phibor',
            'thumbs': 'https://www.avicennaproject.eu/dm/res/api/v1/images/srv?FIF=phibor/_thumbs'
        }
    },
    apiKey: '328451ea11ad481ba4f136e9e5a3b538',
    phiborApp: 'fe',
    criticalEdition: {
        type: {
            public: 'public',
            sample: 'sample'
        }
    }
};



// WEBPACK FOOTER //
// ./src/environments/environment.ts